import { render } from "./adv_buy.vue?vue&type=template&id=39687492&scoped=true"
import script from "./adv_buy.vue?vue&type=script&lang=js"
export * from "./adv_buy.vue?vue&type=script&lang=js"

import "./adv_buy.vue?vue&type=style&index=0&id=39687492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39687492"]])

export default __exports__